import { DownOutlined } from "@ant-design/icons";
import { faMap, faRoad, faSatellite } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Divider } from "antd";
import { useState } from "react";

type MapStyleDropdownProps = {
  mapStyle: string
  setMapStyle: (style: string) => void
  setIsStyleChanging: (changing: boolean) => void
}

const MapStyleDropdown = ({ mapStyle, setMapStyle, setIsStyleChanging }: MapStyleDropdownProps) => {
  const [isStyleDropdownOpen, setIsStyleDropdownOpen] = useState(false);

  return <div
    id="map-style-dropdown"
    style={{
      position: 'absolute',
      top: '10px',
      right: '10px',
      zIndex: 1000,
      backgroundColor: 'white',
      borderRadius: '4px',
      boxShadow: '0 0 10px rgba(0,0,0,0.1)',
      border: '1px solid #ccc'
    }}
  >
    {/* Custom Dropdown */}
    <div
      onClick={(e) => {
        e.stopPropagation();
        setIsStyleDropdownOpen(!isStyleDropdownOpen);
      }}
      style={{
        padding: '8px 12px',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        minWidth: '100px',
        fontSize: '14px'
      }}
    >
      <FontAwesomeIcon icon={faMap} />
      <Divider type="vertical" />
      <span
        style={{ marginRight: '6px' }}>{mapStyle === "mapbox://styles/mapbox/satellite-v9" ? 
        <span>
          <FontAwesomeIcon style={{ marginRight: '6px' }} icon={faSatellite} />
          Satellite</span> : 
        <span>
          <FontAwesomeIcon style={{ marginRight: '6px' }} icon={faRoad} />
          Street</span>}</span>
      <DownOutlined 
        style={{ 
          fontSize: '10px', 
          color: '#666',
          transform: isStyleDropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)',
          transition: 'transform 0.2s'
        }} 
      />
    </div>

      {/* Dropdown Options */}
      {isStyleDropdownOpen && (
      <div
        style={{
          position: 'absolute',
          top: '100%',
          left: '0',
          right: '0',
          backgroundColor: 'white',
          border: '1px solid #ccc',
          borderTop: 'none',
          borderRadius: '0 0 4px 4px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          zIndex: 1001
        }}
      >
        <div
          onClick={(e) => {
            e.stopPropagation();
            const newStyle = "mapbox://styles/mapbox/light-v11";
            if (newStyle !== mapStyle) {
              setIsStyleChanging(true);
              setMapStyle(newStyle);
            }
            setIsStyleDropdownOpen(false);
          }}
          style={{
            padding: '8px 12px',
            cursor: 'pointer',
            borderBottom: '1px solid #f0f0f0',
            backgroundColor: mapStyle === "mapbox://styles/mapbox/light-v11" ? '#f5f5f5' : 'white'
          }}
          onMouseEnter={(e) => {
            if (mapStyle !== "mapbox://styles/mapbox/light-v11") {
              e.currentTarget.style.backgroundColor = '#f9f9f9';
            }
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = mapStyle === "mapbox://styles/mapbox/light-v11" ? '#f5f5f5' : 'white';
          }}
        >
          <FontAwesomeIcon style={{ marginRight: '6px' }} icon={faRoad} />
          Street
        </div>
        <div
          onClick={(e) => {
            e.stopPropagation();
            const newStyle = "mapbox://styles/mapbox/satellite-v9";
            if (newStyle !== mapStyle) {
              setIsStyleChanging(true);
              setMapStyle(newStyle);
            }
            setIsStyleDropdownOpen(false);
          }}
          style={{
            padding: '8px 12px',
            cursor: 'pointer',
            backgroundColor: mapStyle === "mapbox://styles/mapbox/satellite-v9" ? '#f5f5f5' : 'white'
          }}
          onMouseEnter={(e) => {
            if (mapStyle !== "mapbox://styles/mapbox/satellite-v9") {
              e.currentTarget.style.backgroundColor = '#f9f9f9';
            }
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = mapStyle === "mapbox://styles/mapbox/satellite-v9" ? '#f5f5f5' : 'white';
          }}
        >
          <FontAwesomeIcon style={{ marginRight: '6px' }} icon={faSatellite} />
          Satellite
        </div>
      </div>
    )}

  </div>
}

export default MapStyleDropdown